import { authenticatedFetch } from "./http";

export interface FlowDiagnostic {
  query: string;
  handlingUnits: Array<{
    id: string; huNumber: string; itemCode: string; status: string;
    qualityStatus: string; flowStage: string; location: string;
    currentQuantity: number; uom: string;
    splitSourceHandlingUnitNumber: string | null; splitSequence: number | null;
  }>;
  checks: Array<{ severity: "OK" | "WARNING" | "ERROR"; code: string; message: string }>;
  events: Array<{
    category: string; reference: string; status: string; description: string;
    actor?: string; occurredAt: string;
  }>;
}

export function loadFlowDiagnostic(reference: string): Promise<FlowDiagnostic> {
  return authenticatedFetch<FlowDiagnostic>(
    `/api/v1/flow-diagnostics?q=${encodeURIComponent(reference)}`
  );
}
